export default "__VITE_ASSET__xQY0UFCv__";